import PpButtonGroup from '@/components/Buttons/ButtonGroup';
import { GLOBAL_ALIGN } from '@/common/constants/globalAlign';
import { ICON_LOCAL } from '@/common/constants';
import { useElementProperties } from '@/hooks';

export default {
  components: {
    PpButtonGroup
  },
  props: {
    isDisableDistribute: {
      type: Boolean,
      require: true
    },
    disableAlignment: {
      type: Boolean,
      require: true
    }
  },

  setup() {
    const { getProperty } = useElementProperties();

    return {
      getProperty
    };
  },

  data() {
    return {
      TOP: GLOBAL_ALIGN.TOP,
      BOTTOM: GLOBAL_ALIGN.BOTTOM,
      CENTER_V: GLOBAL_ALIGN.CENTER_V,
      CENTER_H: GLOBAL_ALIGN.CENTER_H,
      LEFT: GLOBAL_ALIGN.LEFT,
      RIGHT: GLOBAL_ALIGN.RIGHT,
      DISTRIBUTE_H: GLOBAL_ALIGN.DISTRIBUTE_H,
      DISTRIBUTE_V: GLOBAL_ALIGN.DISTRIBUTE_V,
      iconVerticalDistribute: ICON_LOCAL.VERTICAL_DISTRIBUTE,
      iconHorizontalDistribute: ICON_LOCAL.HORIZONTAL_DISTRIBUTE,
      iconVerticalBottom: ICON_LOCAL.ALIGN_VERTICAL_BOTTOM,
      iconVerticalTop: ICON_LOCAL.ALIGN_VERTICAL_TOP,
      iconHorizontalRight: ICON_LOCAL.ALIGN_HORIZONTAL_RIGHT,
      iconHorizontalCenter: ICON_LOCAL.ALIGN_HORIZONTAL_CENTER,
      iconHorizontalLeft: ICON_LOCAL.ALIGN_HORIZONTAL_LEFT,
      iconVerticalCenter: ICON_LOCAL.ALIGN_VERTICAL_CENTER
    };
  },
  computed: {
    selectedAlignment() {
      return this.getProperty('alignment') || this.TOP;
    }
  },
  methods: {
    /**
     * Detect click on item on text alignment properties
     * @param  {String} data Receive item information
     */
    onClick(data) {
      this.$emit('change', data);
    }
  }
};
